import { IGetContratoFinanceiroByIdUseCase } from "../../../presentation/useCases/read/get_contrato_financeiro_by_id_use_case";
import { ContratoFinanceiro } from "../../models/contrato_financeiro";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";

/**
 * GetContratoFinanceiroByIdUseCase
 */

export class GetContratoFinanceiroByIdUseCase implements IGetContratoFinanceiroByIdUseCase {
  constructor(private readonly repository: IFinanceiroRepository) { }

  async getContratoFinanceiroById(idContrato: number): Promise<ContratoFinanceiro> {
    return await this.repository.getContratoFinanceiroById(idContrato)
  }
}
